export class MakerDetailScreenModel {
    /** メーカーのID */
    makerId: string | null = null;
}
